class NotificationPopup extends HTMLElement {
  connectedCallback() {
    // Mostra il popup solo sulla homepage
    if (window.location.pathname !== "/") return;

    this.popup = document.querySelector(".not-pu-section");
    if (!this.popup) return;

    this.closeBtn = this.popup.querySelector(".newsletter__close-btn");
    this.hasSubscription = this.dataset.hasSubscription === "true";
    this.delay = Number(this.dataset.delay) || 0;
    this.cookie = document.cookie.includes("hideNotificationPopup=true");

    // Non mostrare il popup se:
    // - l'utente è già iscritto alla newsletter
    // - il popup è stato chiuso negli ultimi 3 giorni
    if (this.hasSubscription || this.cookie) return;

    // Mostra il popup dopo il ritardo impostato nel Customizer
    setTimeout(() => {
      this.popup.classList.remove("hidden");
      this.popup.classList.add("wt-popup-fade-in");
    }, this.delay * 1000);

    // Quando l'utente chiude il popup,
    // salva un cookie valido per 3 giorni
    this.closeBtn.addEventListener("click", () => {
      this.popup.classList.add("hidden");
      this.setCookie("hideNotificationPopup", "true", 3);
    });
  }

  setCookie(name, value, days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);

    const expires = `expires=${date.toUTCString()}`;

    document.cookie = `${name}=${value};${expires};path=/`;
  }
}

customElements.define("notification-popup", NotificationPopup);